import {
  PagedResponse,
  PagedResponseEmpty,
  UserAuth,
} from "@ofqual/portal-core/core/types";
import { Activity } from "../domain/Activity";
import { News } from "../domain/News";
import { MODULE_NAME } from "../moduleName";


export const initialNewsState: NewsState = {
  response: PagedResponseEmpty,
  status: "NOT_LOADED",
  hasData: false,
};
export interface NewsState {
  response: PagedResponse<News>;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
  hasData: boolean;
}

export const itemInitialState: NewsItemState = {
  status: "NOT_LOADED",
  item: null,
};

export type NewsItemState = {
  item: News | null;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
};

export type NonNullableItemState = NewsItemState & {
  item: NonNullable<NewsItemState["item"]>;
};

export const resourceVisitInitialState: ResourceVisitState = {
  status: "NOT_LOADED",
  resourceVisits: null,
};
export interface ResourceVisitState {
  resourceVisits: Activity[] | null;
  status: "NOT_LOADED" | "LOADING" | "LOADED";
}

interface ModuleState {
  news: NewsState;
  item: NewsItemState;
  resourceVisits: ResourceVisitState;
}

export enum UserType {
  Unknown = 0,
  Ofqual = 1,
  CCEA = 2,
  AO = 3,
}

// if there is any state from other modules that we use in this module
//  we have an opportunity to at least type it for ourselves.
// If nothing else, store.auth will be needed to get to get the api token
interface RemoteState {
  auth: {
    user: UserAuth
  };
}

export interface GlobalState extends RemoteState {
  [MODULE_NAME]: ModuleState;
}
